<div class="bg-default-300 dark:bg-dark-400 h-[1px] w-full"></div>
